import { Drawer } from "antd";
import ReportForm from "./AddReports";
import { IReportsData } from "@ts/common-types";
import { useState } from "react";
import RevstackReportsGrid from "./RevstackReportsGrid";
import { FaPlus } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";
import usePermissionCheck from "@/hooks/usePermissionCheck";

interface IAddReportsModal {
    addReportsDisplay: boolean,
    setAddReportsDisplay: React.Dispatch<React.SetStateAction<boolean>>,
    existingReportsData: Array<IReportsData>,
    setGetUpdatedReports: React.Dispatch<React.SetStateAction<boolean>>
}

const ReportsSettingsModal: React.FC<IAddReportsModal> = ({ addReportsDisplay, setAddReportsDisplay, existingReportsData, setGetUpdatedReports }) => {
    const [selectedModule, setSelectedModule] = useState<string>("");

    const { canAddReport } = usePermissionCheck()

    return (
        <>
            <Drawer
                title="Reports Settings"
                width={400}
                onClose={() => setAddReportsDisplay(false)}
                open={addReportsDisplay}
            >
                <div className="card bg-light admin-settings-container">
                    <div className="admin-settings-components">
                        <label>Add New Reports</label>
                        <button className="btn btn-primary btn-sm"
                            onClick={() => setSelectedModule("Add Reports")}
                            disabled={!canAddReport}
                        >
                            <FaPlus style={{transform: "translateY(-10%)"}} />
                        </button>
                    </div>
                    <div className="admin-settings-components">
                        <label>Edit Existing Reports</label>
                        <button className="btn btn-primary btn-sm" onClick={() => setSelectedModule("Edit Reports")}><FaPencil style={{transform: "translateY(-10%)"}}/></button>
                    </div>
                </div>

                <Drawer
                    title={selectedModule}
                    width={800}
                    onClose={() => setSelectedModule("")}
                    open={!!selectedModule}
                >
                    {
                        selectedModule === "Add Reports" ?
                            <ReportForm {...{ existingReportsData,setSelectedModule,setGetUpdatedReports }} />
                            :
                            selectedModule === "Edit Reports" ?
                                <div>
                                    <RevstackReportsGrid {...{ existingReportsData,setSelectedModule,setGetUpdatedReports }} />
                                </div>
                                :
                                null

                    }

                </Drawer>


            </Drawer>
        </>
    )
}

export default ReportsSettingsModal